import axios from "axios";

export function setAppToken(appToken) {
  axios.defaults.headers.common["App-Token"] = appToken;
}



// WEBPACK FOOTER //
// ./src/modules/user/user-utils.js